export function quoteSlider() {
    $(".quotes .slider").slick({
        nextArrow: $('.quotes .next'),
        prevArrow: $('.quotes .prev'),
        arrows: true,
        infinite: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [{
            breakpoint: 1200,
            settings: {}
        }]
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/quote-slider.js